import React from "react";

import {
  CalendarToday as CalendarIcon,
  Edit as EditIcon,
  Person as PersonIcon,
} from "@mui/icons-material";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
} from "@mui/material";
import dayjs from "dayjs";

import { IServiceVisitDocumentDto } from "../../../api/PartnerPortalGatewayApi";

interface ServiceVisitDocumentCardProps {
  document: IServiceVisitDocumentDto;
}

export const ServiceVisitDocumentCard: React.FC<ServiceVisitDocumentCardProps> = ({ document }) => {
  const formatDate = (date: dayjs.Dayjs | undefined | null): string => {
    return date ? dayjs(date).format("DD-MMM-YYYY") : "-";
  };

  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: "16px",
        border: "2px solid",
        borderColor: "grey.300",
        transition: "box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out",
        "&:hover": {
          boxShadow: 4,
          borderColor: "primary.main",
        },
      }}
    >
      <CardHeader
        title={document.visitType || "N/A"}
        slotProps={{
          title: {
            variant: "subtitle1",
            fontWeight: 600,
            sx: { wordBreak: "break-word" },
          },
        }}
        subheader={
          <Chip
            icon={<CalendarIcon sx={{ fontSize: 14 }} />}
            label={formatDate(document.visitDate)}
            size="small"
            sx={{ mt: 1, backgroundColor: "#f5f5f5" }}
          />
        }
        sx={{ pb: 0 }}
      />
      <CardContent sx={{ flex: 1, pt: 1 }}>
        <List dense disablePadding>
          <ListItem disableGutters>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <PersonIcon sx={{ color: "text.secondary", fontSize: 20 }} />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="caption" color="text.secondary">
                  Visit By
                </Typography>
              }
              secondary={<Typography variant="body2">{document.visitBy || "-"}</Typography>}
            />
          </ListItem>
          <ListItem disableGutters>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <PersonIcon sx={{ color: "text.secondary", fontSize: 20 }} />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="caption" color="text.secondary">
                  Regional Manager
                </Typography>
              }
              secondary={<Typography variant="body2">{document.regionalManager || "-"}</Typography>}
            />
          </ListItem>
          <ListItem disableGutters>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <EditIcon sx={{ color: "text.secondary", fontSize: 20 }} />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="caption" color="text.secondary">
                  Author
                </Typography>
              }
              secondary={<Typography variant="body2">{document.authorName || "-"}</Typography>}
            />
          </ListItem>
        </List>

        <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap", pt: 1, borderTop: "1px dashed", borderColor: "divider" }}>
          <Box>
            <Typography variant="caption" color="text.secondary">
              Created Date
            </Typography>
            <Typography variant="body2">{formatDate(document.authorCreatedDate)}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">
              Last Modified
            </Typography>
            <Typography variant="body2">{formatDate(document.lastModifiedDate)}</Typography>
          </Box>
        </Box>

      </CardContent>
    </Card>
  );
};
